import { forwardRef, type Ref, type SVGProps } from "react";
const IconFloorPlanFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 2H3c-.55 0-1 .45-1 1v26c0 .55.45 1 1 1h26c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m-1 25.2c0 .44-.36.8-.8.8h-8.63a.86.86 0 0 1-.86-.86c0-.48.38-.86.86-.86h7.71V15.14h-5.14a.86.86 0 0 1-.86-.86c0-.48.38-.86.86-.86h5.14V5.71H5.71v7.71h6.86V9.99c0-.47.38-.86.86-.86s.86.38.86.86v7.71c0 .47-.38.86-.86.86s-.86-.38-.86-.86v-2.57H5.71v11.14h6.86v-3.43c0-.47.38-.86.86-.86s.86.38.86.86v4.29c0 .47-.38.86-.86.86H4.8c-.44 0-.8-.36-.8-.8V4.8c0-.44.36-.8.8-.8h22.4c.44 0 .8.36.8.8z" />
  </svg>
);
const ForwardRef = forwardRef(IconFloorPlanFilledSVG);
ForwardRef.displayName = "IconFloorPlanFilled";
export { ForwardRef as IconFloorPlanFilled };
